export enum Enum_Map_Types {
    STANDARD_OSM = "standard_osm",
    STATIC_IMAGE = "static_image",
}
